const items = [
  "₹12,500 Savings",
  "10 Laser Sessions",
  "Annual Maintenance up to 10 Years",
  "Doctor-Supervised",
  "No-Cost EMI Available",
  "Ameerpet · Hyderabad",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative border-y border-champagne/50 bg-sand/60 py-5 overflow-hidden" aria-hidden="true">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {items.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center">
              <span className="px-8 font-display text-lg md:text-xl font-light italic tracking-wide text-teal/80 whitespace-nowrap">
                {item}
              </span>
              <span className="w-1.5 h-1.5 rotate-45 bg-champagne-dark/70" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
